module.exports = __webpack_public_path__ + "static/media/logo_qualdo-drx.3cdb7639.svg";